import Camera from "./Camera";
import Show from "./Show";

export default Camera;
export const Gallery = Show;
